
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/assembly-chunav/puducherry/[assembly]",
      function () {
        return require("private-next-pages/elections/assembly-chunav/puducherry/[assembly].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/assembly-chunav/puducherry/[assembly]"])
      });
    }
  